import * as types from './actionTypes';

export function showLoadingSpinner() {
  return { type: types.LOADING_SPINNER_SHOW };
}

export function hideLoadingSpinner() {
  return { type: types.LOADING_SPINNER_HIDE };
}
